import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { Instagram, Linkedin, Mail, Phone } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="bg-ink text-beige" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-2">
          <Logo reverse size="text-3xl" />
          <p className="mt-5 text-beige/60 max-w-sm leading-relaxed">
            Il digitale fatto a regola d'arte. Aiutiamo aziende e professionisti
            a farsi trovare su internet, con un sito fatto come si deve.
          </p>
        </div>
        <div>
          <h4 className="font-semibold mb-4 text-coral text-sm uppercase tracking-widest">Pagine</h4>
          <ul className="space-y-3 text-beige/70">
            <li><Link to="/servizi" className="hover:text-coral transition-colors" data-testid="footer-link-servizi">Servizi</Link></li>
            <li><Link to="/prezzi" className="hover:text-coral transition-colors" data-testid="footer-link-prezzi">Prezzi</Link></li>
            <li><Link to="/chi-siamo" className="hover:text-coral transition-colors" data-testid="footer-link-chisiamo">Chi Siamo</Link></li>
            <li><Link to="/portfolio" className="hover:text-coral transition-colors" data-testid="footer-link-portfolio">Portfolio</Link></li>
            <li><Link to="/contatti" className="hover:text-coral transition-colors" data-testid="footer-link-contatti">Contatti</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-semibold mb-4 text-coral text-sm uppercase tracking-widest">Contatti</h4>
          <ul className="space-y-3 text-beige/70">
            <li className="flex items-center gap-2"><Phone size={16} /> +39 375 9920268</li>
            <li className="flex items-center gap-2"><Mail size={16} /> info@mcstudio.it</li>
          </ul>
          <div className="flex gap-4 mt-5">
            <a href="https://instagram.com" target="_blank" rel="noreferrer" className="hover:text-coral transition-colors" data-testid="footer-social-instagram"><Instagram size={20} /></a>
            <a href="https://linkedin.com" target="_blank" rel="noreferrer" className="hover:text-coral transition-colors" data-testid="footer-social-linkedin"><Linkedin size={20} /></a>
          </div>
        </div>
      </div>
      <div className="border-t border-beige/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col sm:flex-row justify-between items-center gap-3 text-beige/40 text-sm">
          <span>© {new Date().getFullYear()} MC Studio. Tutti i diritti riservati.</span>
          <span className="uppercase tracking-[0.2em] text-xs">Il digitale fatto a regola d'arte</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
